import generate from '@bingads-webui-component-legacy/form/viewmodel/control/readonly-computed';

export default function label(local, attrs, custom, viewModel) {
  local.label = generate(custom.label, viewModel);
}
